import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'

import { equipmentResourceDefinition } from './equipment.definition'
import { locationResourceDefinition } from './location.definition'
import { materialResourceDefinition } from './material.definition'
import { struxTagsResourceDefinition } from './struxTags.definition'
import { IResourceDefinition } from './types'

const RESOURCE_DEFINITIONS: Partial<
  Record<ResourceTypeId, IResourceDefinition>
> = {
  [ResourceTypeId.OFFLOADING_EQUIPMENT]: equipmentResourceDefinition,
  [ResourceTypeId.SENSORS]: struxTagsResourceDefinition,
  [ResourceTypeId.MATERIALS]: materialResourceDefinition,
  [ResourceTypeId.LOCATIONS]: locationResourceDefinition,
}

export const getResourceDefinition = (
  resourceTypeId?: string,
): IResourceDefinition | undefined => {
  if (!resourceTypeId) {
    return undefined
  }

  return RESOURCE_DEFINITIONS[resourceTypeId as ResourceTypeId]
}

export const getResourceFieldDefinition = (
  resourceTypeId: string | undefined,
  propertyKey: string,
): IResourceDefinition['fields'][string] | undefined => {
  const definition = getResourceDefinition(resourceTypeId)
  if (!definition) {
    return undefined
  }

  return (
    definition.fields[propertyKey] ||
    definition.map?.syntheticFields?.[propertyKey]
  )
}

export const isResourcePropertyBackedField = (
  resourceTypeId: string | undefined,
  propertyKey: string,
): boolean =>
  !getResourceDefinition(resourceTypeId)?.valueSources?.[propertyKey]

export * from './equipment.definition'
export * from './location.definition'
export * from './material.definition'
export * from './struxTags.definition'
export * from './types'
